import { render, staticRenderFns } from "./ProductEditModal.vue?vue&type=template&id=d070d10c&scoped=true"
import script from "./ProductEditModal.vue?vue&type=script&lang=js"
export * from "./ProductEditModal.vue?vue&type=script&lang=js"
import style0 from "./ProductEditModal.vue?vue&type=style&index=0&id=d070d10c&prod&scoped=true&lang=css"
import style1 from "./ProductEditModal.vue?vue&type=style&index=1&id=d070d10c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d070d10c",
  null
  
)

export default component.exports